import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { Node, md } from 'djedi-react'
import { Field, reduxForm, stopAsyncValidation } from 'redux-form/immutable'
import { connect } from 'react-redux'

import { addReducer, removeReducer } from 'state/reducers'
import { addSaga, removeSaga } from 'state/sagas'

import Page from 'layouts/Page'
import Masthead, { MastheadOverlap } from 'layouts/Masthead'
import Container from 'layouts/Container'
import { FormFieldset } from 'layouts/Form'
import Box, { BoxSection } from 'layouts/Box'
import Spinner from 'components/Spinner'
import Callout from 'components/Callout'
import Input from 'components/Input'
import Button from 'components/Button'
import Link from 'components/Link'

import { required } from 'utilities/validators'
import { reverse } from 'utilities/routes'
import { PARENT_SIGNUP as ROUTE_PARENT_SIGNUP } from 'views/Signup/constants'
import { PASSWORD_RESET_REQUEST as ROUTE_PASSWORD_RESET_REQUEST } from 'views/PasswordReset/constants'

import { NAME } from './constants'
import reducer from './reducer'
import actions from './actions'
import saga from './sagas'
import selector from './selectors'

import styles from './styles.css'

const Message = ({ message }) => {
  switch (message) {
    case 'invite':
      return (
        <React.Fragment>
          För att se inbjudan behöver du ett konto hos friendtivity.{' '}
          <Link href={reverse(ROUTE_PARENT_SIGNUP)}>Registrera dig</Link> eller
          logga in.
        </React.Fragment>
      )
    case 'activity':
      return (
        <React.Fragment>
          För att skapa en aktivitet behöver du ett konto hos friendtivity.{' '}
          <Link href={reverse(ROUTE_PARENT_SIGNUP)}>Registrera dig</Link> eller
          logga in.
        </React.Fragment>
      )
    default:
      return process.env.NODE_ENV === 'development'
        ? `Unknown message: ${message}`
        : null
  }
}

Message.propTypes = {
  message: PropTypes.string.isRequired,
}

class LoginPage extends Component {
  static propTypes = {
    dispatch: PropTypes.func.isRequired,
    handleSubmit: PropTypes.func.isRequired,
    asyncValidating: PropTypes.bool,
    location: PropTypes.object.isRequired,
    account: PropTypes.oneOfType([
      PropTypes.bool.isRequired,
      PropTypes.object.isRequired,
    ]),
  }

  static defaultProps = {
    asyncValidating: false,
    account: false,
  }

  componentDidMount() {
    addReducer(NAME, reducer)
    addSaga(NAME, saga)
  }

  componentWillUnmount() {
    removeReducer(NAME)
    removeSaga(NAME)
  }

  onSubmit = values => this.props.dispatch(actions.submit(values.toJS()))

  render() {
    const { message, next } = this.props.location.query || {}
    const { account } = this.props

    /*
        Show spinner if user visits a page that requires login but the status
        of the account is unknown. This prevents login form from flashing
        before user account status has been fetched
        */
    if (next && account === false) {
      return <Spinner width="45" height="45" center key="spinner" />
    }

    return (
      <Page
        // {...this.props.meta.toJS()}
        className={styles.root}
        title="Logga in"
        key="page"
      >
        <Masthead overlap>
          <Container size="medium">
            <Node uri="login/text1.md">
              {md`
                # Logga in


              `}
            </Node>
          </Container>
        </Masthead>
        <MastheadOverlap>
          <Container size="medium">
            <form onSubmit={this.props.handleSubmit(this.onSubmit)}>
              <Box shadow>
                <BoxSection>
                  {message && (
                    <Callout type="error">
                      <Message message={message} />
                    </Callout>
                  )}
                  <FormFieldset>
                    <Field
                      component={Input}
                      label="Din e-postadress"
                      type="email"
                      name="username"
                      validate={[required]}
                    />

                    <Field
                      component={Input}
                      label="Ange lösenord"
                      type="password"
                      name="password"
                      validate={[required]}
                    />
                  </FormFieldset>

                  <div
                    style={{
                      textAlign: 'center',
                    }}
                  >
                    <Button loading={this.props.asyncValidating} rounded>
                      Logga in
                    </Button>
                    <p>
                      Inget konto?{' '}
                      <Link href={reverse(ROUTE_PARENT_SIGNUP)}>
                        Registrera dig
                      </Link>
                      .
                    </p>
                    <p>
                      <Link href={reverse(ROUTE_PASSWORD_RESET_REQUEST)}>
                        Har du glömt ditt lösenord?
                      </Link>
                    </p>
                  </div>
                </BoxSection>
              </Box>
            </form>
          </Container>
        </MastheadOverlap>
      </Page>
    )
  }
}

export default connect(selector)(
  reduxForm({
    form: NAME,
    onChange: (values, dispatch) => {
      dispatch(stopAsyncValidation(NAME, { clear: true }))
    },
  })(LoginPage),
)



// WEBPACK FOOTER //
// ../source/views/Login/index.js